import { RoutingNavigation } from '../models/utils/routing-navigation';

const ROUTES = Object.freeze({
	SIMULATOR: '/credit/simulador',
	PERSONAL_DATA: '/account/personal-data',
	INE_FRONT: '/account/ine-front',
	INE_BACK: '/account/ine-back',
	PHOTO_PROOF: '/account/photo-proof',
	SELFIE: '/account/selfie',
	VIDEO_RECORDING: '/account/video-recording',
	CREDIT_HISTORY_CONSULT: '/credit/credit-history-consult',
	CREDIT_SURVEY: '/credit/credit-survey',
	PLD_OCUPATION: '/account/socio-economic-data',
	GENERATE_PASSWORD: '/account/generate-password',
	USER_BENEFITS: '/account/social-contribution',
	CONGRATULATIONS: '/account/congratulations',
	DECLINED_OFFER: '/account/declined-offer',
	PROMO: '/sites/promo',
	OFFER_CONFIRMATION: '/account/offer-confirmation',
	HOME: '/sites/home',
	BILLING: '/account/billing',
	SIGNATURE: '/account/signature',
	CREDIT_STATUS: '/credit/credit-status',
	DOWNLOAD_FILES: '/credit/download-files',
	HOME_INVESTMENT: '/sites/home-investment',
	HOME_TDC: '/sites/home-tdc',
	TDC_OFFER_CONFIRMATION: '/account/tdc-offer-confirmation',
	TDC_PERSONAL_DATA: '/account/tdc-personal-data',
	TDC_CONGRATULATIONS: '/account/congratulations-tdc',
	HOME_PREAUTHORIZED: '/sites/home-preauthorized',
});

const INITIAL_ROUTE = '/';

const AVAILABLE_ROUTES: Array<string> = Object.values(ROUTES);

export { ROUTES, INITIAL_ROUTE, AVAILABLE_ROUTES };
